import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {ErrorHandlingComponent} from '../error-handling.component';
import {BankAccount} from '../model/bank-account';

@Component({
    selector: 'app-bank-account-details',
    templateUrl: './bank-account-details.component.html',
    styleUrls: ['../loan-application-flow-component/application-flow.css', 'bank-account-details.component.css']
})
export class BankAccountDetailsComponent extends ErrorHandlingComponent implements OnInit {
    bankAccountFormGroup: FormGroup;
    accountTypes = [
        {value: 'saving', viewValue: 'Saving'},
        {value: 'current', viewValue: 'Current'}
    ];

    @Input()
    public bankAccount: BankAccount;

    constructor(formBuilder: FormBuilder) {
        super();

        this.bankAccountFormGroup = formBuilder.group({
            accountHolderName: new FormControl(null, Validators.required),
            accountType: new FormControl(undefined, Validators.required),
            accountNumberGroup: formBuilder.group({
                accountNumber: new FormControl(null, Validators.required),
                repeatedAccountNumber: new FormControl(null, Validators.required)
            }, {validator: BankAccountDetailsComponent.validateRepeatedAccountNumber})
        });
    }

    private static validateRepeatedAccountNumber(control: AbstractControl): ValidationErrors | null {
        const accountNumberFormControl = control.get('accountNumber');
        const repeatedAccountNumberFormControl = control.get('repeatedAccountNumber');
        const originalValue = accountNumberFormControl.value;
        const repeatedValue = repeatedAccountNumberFormControl.value;
        if (repeatedValue !== originalValue) {
            return {match: true};
        } else {
            return null;
        }
    }

    ngOnInit(): void {
        this.prepopulate();
    }

    public clearBankAccountFields(): void {
        this.bankAccountFormGroup.controls.accountHolderName.reset();
        this.bankAccountFormGroup.controls.accountType.reset();
        this.bankAccountFormGroup['controls'].accountNumberGroup['controls'].accountNumber.reset();
        this.bankAccountFormGroup['controls'].accountNumberGroup['controls'].repeatedAccountNumber.reset();
    }

    public isFormValid(): boolean {
        return this.isValid(this.bankAccountFormGroup);
    }

    public getBankAccountDetails(): BankAccount {
        const accountNumber = this.bankAccountFormGroup['controls'].accountNumberGroup['controls'].accountNumber.value;
        const accountType = this.bankAccountFormGroup.controls.accountType.value;
        const accountHolderName = this.bankAccountFormGroup.controls.accountHolderName.value;

        return new BankAccount(
            accountNumber,
            accountType,
            accountHolderName,
            null,
            null,
            null,
            null,
            null
        );
    }

    protected errorMessages(): object {
        return {
            accountHolderName: [{
                type: 'required',
                message: 'Please enter your name as mentioned in the bank account'
            }],
            accountType: [{
                type: 'required',
                message: 'Please select the account type'
            }],
            accountNumber: [{
                type: 'required',
                message: 'Please provide a valid account number'
            }],
            repeatedAccountNumber: [{
                type: 'required',
                message: 'Please provide a valid account number'
            }],
            accountNumberGroup: [{
                type: 'match',
                message: 'Account Numbers do not match. Please provide the same account number in both the fields.'
            }]
        };
    }

    private prepopulate(): void {
        if (this.bankAccount) {
            this.bankAccountFormGroup.patchValue({
                accountType: this.bankAccount.account_type,
                accountHolderName: this.bankAccount.accountHolderName,
                accountNumberGroup: {
                    accountNumber: this.bankAccount.account_no,
                    repeatedAccountNumber: this.bankAccount.account_no,
                }
            });
        }
    }

    public isAccountNumberEmpty(): boolean {
        return !this.bankAccountFormGroup['controls'].accountNumberGroup['controls'].accountNumber.value;
    }
}
